export const RESET_PASSWORD_KEY = 'rp_reset'
export const SETTINGS_STORAGE_KEY = 'rp_us'
export const BRANDING_PRIMARY = 'primary'
export const BRANDING_SECONDARY = 'secondary'
export const BRANDING_BG_URL = 'background_url'
export const BRANDING_COLOR_LOGO = 'color_logo_image_url'
export const BRANDING_WHITE_LOGO = 'white_logo_image_url'
export const BRANDING_BG_IMAGE = 'property_image_url'
export const BRANDING_BUTTON_PRIMARY_COLOR = 'button_primary'
export const BACKGROUND_COLOR = 'background_color'
export const FOREGROUND_COLOR = 'foreground_color'
export const BUTTON_TEXT = 'button_text'
export const INPUT_BORDER_OUTLINE = 'input_border_outline'
export const BRANDING_PRIMARY_TEXT = 'primary_text'
export const BRANDING_SECONDARY_TEXT = 'secondary_text'
export const BRANDING_BUTTON_COLOR = 'button_color'
export const PRIMARY_DEFAULT_COLOR = '#ED2238'
export const PRIMARY_EMBEDDED_DEFAULT_COLOR = '#FFFFFF'
export const SECONDARY_DEFAULT_COLOR = '#3361aa'
export const BUTTON_PRIMARY_DEFAULT_COLOR = '#641083'
export const BUTTON_EMBEDDED_PRIMARY_DEFAULT_COLOR = '#92C9EB'
export const BACKGROUND_DEFAULT_COLOR = '#02070E'
export const FOREGROUND_DEFAULT_COLOR = '#1D282F'
export const INPUT_BORDER_OUTLINE_DEFAULT_COLOR = '#eff8fd'
export const BUTTON_DEFAULT_TEXT_COLOR = '#0a2245'